import * as React from 'react';
import { inputDriverFactory } from './Input.legacy.driver';
import { Input } from '.';
import { createDriverFactory } from '@wix/wix-ui-test-utils/driver-factory';

describe('Input', () => {
  const createDriver = createDriverFactory(inputDriverFactory);

  it('should render', () => {
    const value = 'hello!';
    const driver = createDriver(<Input value={value} />);
    expect(driver.getValue()).toEqual(value);
  });
});
